import { PktIcon } from '@/components/icon/Icon'

export default function Input() {
  const grumpyCatSvg = `
               <svg width="200" height="80" viewBox="0 0 240 80" xmlns="http://www.w3.org/2000/svg">
                 <text x="20" y="35">My</text>
                 <text x="40" y="35">cat</text>
                 <text x="55" y="55">is</text>
                 <text x="65" y="55">Grumpy!</text>
               </svg>`

  return (
    <>
      <main className="page-main pkt-container">
        <h1>Icon</h1>

        <section className="component">
          <h1>Small</h1>
          <PktIcon name="arrow" className="pkt-icon--small" />
          <PktIcon name="face-neutral" className="pkt-icon--small" />
          <PktIcon name="face-neutral" className="pkt-icon--small" />
          <PktIcon
            name="spinner-blue"
            path="https://punkt-cdn.oslo.kommune.no/latest/animations/"
            className="pkt-icon--small"
          />
          <h1>Medium</h1>
          <PktIcon name="thumbs-up" />
          <PktIcon name="alert-circle" />
          <PktIcon name="location-pin" />
          <PktIcon name="loader" path="https://punkt-cdn.oslo.kommune.no/latest/animations/" />
          <h1>Large</h1>
          <PktIcon name="message" className="pkt-icon--large" />
          <PktIcon name="vue" className="pkt-icon--large" />
          <PktIcon
            name="spinner"
            path="https://punkt-cdn.oslo.kommune.no/latest/animations/"
            className="pkt-icon--large"
          />
        </section>
        <section className="component">
          <h2>Ikon hentet fra CDN</h2>
          <PktIcon name={'arrow'} />
        </section>
      </main>
    </>
  )
}
